import { render } from "./TmplItemEdit.vue?vue&type=template&id=062598b2"
import script from "./TmplItemEdit.vue?vue&type=script&lang=js"
export * from "./TmplItemEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__